/* ==========================================================================
   pf-config.js — configuracion de los sliders, extraida literalmente de
   window.__pagefly_setting__.elementData del HTML servido por
   mx.store.dji.com (reference/index-raw.html). No inventar valores aqui.
   --------------------------------------------------------------------------
   PF_ARROWS / PF_DOTS recogen el comportamiento MEDIDO en el sitio real
   (.measure/m-*.json): que flechas y que puntos de paginacion se pintan.
     always : las dos flechas siempre visibles (slideshow con loop)
     edge   : la flecha del extremo alcanzado pasa a visibility:hidden
     never  : PageFly deja las dos flechas en visibility:hidden
   ========================================================================== */
window.PF_ELEMENT_DATA = {
  "pf-e3488b4f18bb-11_": {
    "type": "Slideshow",
    "autoPlay": true,
    "autoPlayDelay": 6000,
    "loop": true,
    "pauseOnHover": true,
    "navStyle": "nav-style-1",
    "paginationStyle": "pagination-style-1",
    "slidesToShow": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    },
    "slidesToScroll": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    }
  },
  "pf-263_": {
    "type": "MediaMain3",
    "autoPlay": false,
    "autoPlayDelay": 0,
    "loop": false,
    "pauseOnHover": false,
    "navStyle": "nav-style-2",
    "paginationStyle": "none",
    "slidesToShow": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    },
    "slidesToScroll": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    }
  },
  "pf-316_": {
    "type": "MediaMain3",
    "autoPlay": false,
    "autoPlayDelay": 0,
    "loop": false,
    "pauseOnHover": false,
    "navStyle": "nav-style-2",
    "paginationStyle": "none",
    "slidesToShow": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    },
    "slidesToScroll": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    }
  },
  "pf-372_": {
    "type": "MediaMain3",
    "autoPlay": false,
    "autoPlayDelay": 0,
    "loop": false,
    "pauseOnHover": false,
    "navStyle": "nav-style-2",
    "paginationStyle": "none",
    "slidesToShow": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    },
    "slidesToScroll": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    }
  },
  "pf-407_": {
    "type": "MediaMain3",
    "autoPlay": false,
    "autoPlayDelay": 0,
    "loop": false,
    "pauseOnHover": false,
    "navStyle": "nav-style-2",
    "paginationStyle": "none",
    "slidesToShow": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    },
    "slidesToScroll": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    }
  },
  "pf-e32585fcdd9d-10_": {
    "type": "Slideshow",
    "autoPlay": true,
    "autoPlayDelay": 6000,
    "loop": true,
    "pauseOnHover": true,
    "navStyle": "nav-style-1",
    "paginationStyle": "pagination-style-1",
    "slidesToShow": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    },
    "slidesToScroll": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    }
  },
  "pf-e32585fcdd9d-367_": {
    "type": "MediaMain3",
    "autoPlay": false,
    "autoPlayDelay": 0,
    "loop": false,
    "pauseOnHover": false,
    "navStyle": "nav-style-1",
    "paginationStyle": "none",
    "slidesToShow": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    },
    "slidesToScroll": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    }
  },
  "pf-e32585fcdd9d-383_": {
    "type": "MediaMain3",
    "autoPlay": false,
    "autoPlayDelay": 0,
    "loop": false,
    "pauseOnHover": false,
    "navStyle": "nav-style-1",
    "paginationStyle": "none",
    "slidesToShow": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    },
    "slidesToScroll": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    }
  },
  "pf-e32585fcdd9d-401_": {
    "type": "MediaMain3",
    "autoPlay": false,
    "autoPlayDelay": 0,
    "loop": false,
    "pauseOnHover": false,
    "navStyle": "nav-style-1",
    "paginationStyle": "none",
    "slidesToShow": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    },
    "slidesToScroll": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    }
  },
  "pf-e32585fcdd9d-475_": {
    "type": "MediaMain3",
    "autoPlay": false,
    "autoPlayDelay": 0,
    "loop": false,
    "pauseOnHover": false,
    "navStyle": "nav-style-1",
    "paginationStyle": "none",
    "slidesToShow": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    },
    "slidesToScroll": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    }
  },
  "pf-e32585fcdd9d-491_": {
    "type": "MediaMain3",
    "autoPlay": false,
    "autoPlayDelay": 0,
    "loop": false,
    "pauseOnHover": false,
    "navStyle": "nav-style-1",
    "paginationStyle": "none",
    "slidesToShow": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    },
    "slidesToScroll": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    }
  },
  "pf-e32585fcdd9d-509_": {
    "type": "MediaMain3",
    "autoPlay": false,
    "autoPlayDelay": 0,
    "loop": false,
    "pauseOnHover": false,
    "navStyle": "nav-style-1",
    "paginationStyle": "none",
    "slidesToShow": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    },
    "slidesToScroll": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    }
  },
  "pf-a9b172d0381c-37_": {
    "type": "MediaMain3",
    "autoPlay": false,
    "autoPlayDelay": 0,
    "loop": false,
    "pauseOnHover": false,
    "navStyle": "nav-style-1",
    "paginationStyle": "none",
    "slidesToShow": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    },
    "slidesToScroll": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    }
  },
  "pf-a9b172d0381c-53_": {
    "type": "MediaMain3",
    "autoPlay": false,
    "autoPlayDelay": 0,
    "loop": false,
    "pauseOnHover": false,
    "navStyle": "nav-style-1",
    "paginationStyle": "none",
    "slidesToShow": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    },
    "slidesToScroll": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    }
  },
  "pf-a9b172d0381c-71_": {
    "type": "MediaMain3",
    "autoPlay": false,
    "autoPlayDelay": 0,
    "loop": false,
    "pauseOnHover": false,
    "navStyle": "nav-style-1",
    "paginationStyle": "none",
    "slidesToShow": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    },
    "slidesToScroll": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    }
  },
  "pf-a9b172d0381c-105_": {
    "type": "MediaMain3",
    "autoPlay": false,
    "autoPlayDelay": 0,
    "loop": false,
    "pauseOnHover": false,
    "navStyle": "nav-style-1",
    "paginationStyle": "none",
    "slidesToShow": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    },
    "slidesToScroll": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    }
  },
  "pf-a9b172d0381c-121_": {
    "type": "MediaMain3",
    "autoPlay": false,
    "autoPlayDelay": 0,
    "loop": false,
    "pauseOnHover": false,
    "navStyle": "nav-style-1",
    "paginationStyle": "none",
    "slidesToShow": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    },
    "slidesToScroll": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    }
  },
  "pf-a9b172d0381c-139_": {
    "type": "MediaMain3",
    "autoPlay": false,
    "autoPlayDelay": 0,
    "loop": false,
    "pauseOnHover": false,
    "navStyle": "nav-style-1",
    "paginationStyle": "none",
    "slidesToShow": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    },
    "slidesToScroll": {
      "all": 1,
      "laptop": 1,
      "tablet": 1,
      "mobile": 1
    }
  }
};

/* Productos agotados: todas sus variantes llegan con
   "available": false en window.__pageflyProducts del HTML servido.
   PageFly les sustituye el texto por data-soldout y les pone disabled. */
window.PF_SOLD_OUT = [
  "8931943383237",
  "8912801333445",
  "8912801497285",
  "8931943481541"
];

/* Politica de flechas por slider (medida en el sitio real) */
window.PF_ARROWS = {
  'pf-e3488b4f18bb-11_':  'always',  /* slideshow de portada (escritorio) */
  'pf-e32585fcdd9d-10_':  'always',  /* slideshow de portada (movil)      */
  'pf-0a9c8d0cd4e1-10_':  'edge',    /* barra de categorias               */
  'pf-e32585fcdd9d-137_': 'edge',    /* barra de categorias (movil)       */
  'pf-260_': 'never', 'pf-313_': 'never', 'pf-369_': 'never', 'pf-404_': 'never'
};

/* Solo los slideshows pintan puntos de paginacion: los .pf-slider-nav de los
   sliders de 4 productos miden 0px de alto en el sitio real. */
window.PF_DOTS = {
  'pf-e3488b4f18bb-11_':  true,
  'pf-e32585fcdd9d-10_':  true
};
